import moment from "moment";

export function fromUnix(unix) {
  return moment(new Date(unix * 1000));
}

export function unixToString(unix) {
  return fromUnix(unix).format("MM/DD/YY HH:mm:ss");
}
